module.exports = __webpack_public_path__ + "img/close.3208a377.svg";